<button class="vwui-btn is-primary"
        [class.disabled]="!canSubmit || (submitPending$ | async) === true"
        (click)="submit()"
>
    Formulier versturen
</button>
